export const GET_ALL_SUBSCRIPTIONS = "GET_ALL_SUBSCRIPTIONS";
export const GET_SUBSCRIPTED_USERS = "GET_SUBSCRIPTED_USERS";
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const DELETE_COMPANY = "DELETE_COMPANY"
export const DELETE_SUBSCRIBER = "DELETE_SUBSCRIBER"
export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS";